
export default function (node) {
  if (!node) {
    return document;
  }

  if (node.nodeType === Node.DOCUMENT_NODE) {
    return node;
  }

  return node.ownerDocument || document;
}
//# sourceMappingURL=get-document.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/esm/util/get-document.js
// module id = 49
// module chunks = 4